import Rest from './rest';
import _ from 'lodash';
import axios from 'axios';
import Promise from 'bluebird';

// Utils
import { getDateRangeFilter } from 'utils/filter-utils';
import { alerts } from 'modules/alerts/actions';


export default class PurchaseOrder extends Rest {
  static path = 'purchaseorder';
  static defaultQuery = {
    sort: 'date DESC',
    load: [
      'ticket.agreement',
      'agreement',
      'company',
      'createdBy',
      'lineItems',
      'lineItems.expenseBillLineItems',
      'expenseBills.agreement',
      'expenseBills.ticket.agreement',
      'expenseBills.lineItems',
      'expenseBills.lineItems.purchaseOrderLineItem',
      'expenseBills.receipt'
    ]
  }

  static run(service) {
    return Promise.resolve(axios.post('/api/purchaseorder/run', { service }))
      .tap(response => alerts.success({ title: response.message }))
      .tap(this.logRequest);
  }

  static mapFilters(filters) {
    // Use omitBy isEmpty because empty filters will be set to empty string rather than undefined,
    // which will break filtering
    const {
      company,
      id,
      ticket,
      date,
      vendor,
      search,
      purchaseOrderStatus,
      purchasedBy,
      team
    } = filters;

    // If the id filter is applied, ignore all other filters
    // (and turn off the api's default status filtering)
    if (id) return { id, status: { '!': null } };

    return {
      'agreement.company': company,
      'agreement.company.team': team,
      ticket,
      date: getDateRangeFilter(date),
      vendor: { contains: vendor },
      search,
      or: getPurchaseOrderStatusFilter(purchaseOrderStatus),
      createdBy: purchasedBy ? { or: { in: purchasedBy, is: null } } : undefined
    };
  }
}


// Internal helper function
function getPurchaseOrderStatusFilter(status) {
  if (!status || !status.length) return;

  const filter = {};
  if (_.includes(status, 'Not Fully Charged')) filter.unbilledQuantity = { '>': 0 };
  if (_.includes(status, 'Not Fully Approved')) filter.unapprovedExpenseBills = { '>': 0 };
  if (_.includes(status, 'Complete')) filter.and = { unbilledQuantity: { '=': 0 }, unapprovedExpenseBills: { '=': 0 } };
  return filter;
}
